import { ReactElement, useMemo } from 'react';
import styled from 'styled-components';

import {
   appendTestableCustomAttribute,
   appendTestableElementAttributes,
   DocplannerIcon,
   PatientPortalIcon,
} from '@dreryk/react-components';

import { createAppointmentSourceVisitor } from '~libs.shared.appointments';

const StyledAvailabilitySourceIcon = styled.div`
   height: 16px;
   width: 16px;
`;

StyledAvailabilitySourceIcon.displayName = 'StyledAvailabilitySourceIcon';

const StyledAvailabilitySourceIconAccessability = styled.div`
   border-radius: 16px;
   height: 18px;
   background-color: white;
`;

StyledAvailabilitySourceIcon.displayName = 'StyledAvailabilitySourceIcon';

type AvailabilitySourceIconProps = {
   readonly sourceLabel: string | undefined;
};

export const AvailabilitySourceIcon = (props: AvailabilitySourceIconProps): JSX.Element | null => {
   const sourceIcon = useMemo(() => {
      if (!props.sourceLabel) {
         return null;
      }
      return createAppointmentSourceVisitor<ReactElement | null>(props.sourceLabel)({
         visitDocplanner: () => (
            <StyledAvailabilitySourceIconAccessability>
               <DocplannerIcon />
            </StyledAvailabilitySourceIconAccessability>
         ),
         visitPatientPortal: () => <PatientPortalIcon />,
         visitEgabinet: () => null,
      });
   }, [props.sourceLabel]);

   if (!sourceIcon) {
      return null;
   }

   return (
      <StyledAvailabilitySourceIcon
         {...appendTestableElementAttributes('source')}
         {...appendTestableCustomAttribute('source', props.sourceLabel)}
      >
         {sourceIcon}
      </StyledAvailabilitySourceIcon>
   );
};
